module.exports = __webpack_public_path__ + "static/media/guest-house-primary.b81a1746.jpg";